export const ADD_TO_CART = "DOMAIN_ADD_TO_CART/ADD_TO_CART";
export const REMOVE_FROM_CART = "DOMAIN_ADD_TO_CART/REMOVE_FROM_CART";
export const CLEAR_CART = "DOMAIN_ADD_TO_CART/CLEAR_CART";
